export default () => {
    document.addEventListener("DOMContentLoaded", function () {
      const faqSections = document.querySelectorAll('.blockFaq__category-content');
      const faqLinks = document.querySelectorAll('.blockFaq__list a');
  
      if (!faqSections.length || !faqLinks.length) return;
  
      faqLinks.forEach(link => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          
          // Remove active class from all links
          faqLinks.forEach(l => l.classList.remove('active'));
          
          // Add active class to clicked link
          this.classList.add('active');
  
          const targetId = this.getAttribute('href');
          const escapedId = targetId.replace(/^#(\d)/, '#\\3$1 ').replace(/\s$/, '');
          const targetEl = document.querySelector(escapedId);
  
          if (targetEl) {
            const topOffset = targetEl.getBoundingClientRect().top + window.scrollY - 150;
            window.scrollTo({
              top: topOffset,
              behavior: 'smooth'
            });
          } else {
            console.warn('Nie znaleziono elementu:', targetId);
          }
        });
      });
    });
  };
  